import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import { initI18n } from "@core/i18n";
import {
  CustomTranslationContextProvider,
  setupCustomTranslations,
} from "@utils/translations/CustomTranslation/CustomTranslationContextProvider/CustomTranslationContextProvider";

import { App } from "./App";
import { isMswEnabled, redirectToWorkerScope } from "./mswHelpers";

const enableMocking = async () => {
  if (!isMswEnabled()) {
    return false;
  }

  if (redirectToWorkerScope()) {
    return true;
  }

  const { startWorker } = await import("@mocks/browser");

  await startWorker();

  return false;
};

const rootElement = document.getElementById("root");
if (!rootElement) throw new Error("Failed to find the root element");
const root = createRoot(rootElement);

const i18nInitPromise = initI18n();

if (import.meta.env.VITE_APP_EDIT_TRANSLATION === "true") {
  setupCustomTranslations();
}

enableMocking()
  .then((redirected) => {
    if (redirected) {
      return undefined;
    }

    return i18nInitPromise.then(() => {
      root.render(
        <StrictMode>
          {import.meta.env.VITE_APP_EDIT_TRANSLATION === "true" ? (
            <CustomTranslationContextProvider>
              <App />
            </CustomTranslationContextProvider>
          ) : (
            <App />
          )}
        </StrictMode>,
      );
    });
  })
  .catch((error) => {
    console.error("[bootstrap] Failed to start the application:", error);
  });
